export default {
  name: 'marking--notificationStatusChange',
  apiService: 'shoes',
  apiPath: '/admin/notification_status_change',
};